export const ADD_TO_TROLLEY_DESCRIPTION = 'add_to_cart' as const;
export const REMOVE_FROM_TROLLEY_DESCRIPTION = 'remove_from_cart' as const;
